import { observer } from 'mobx-react'
import React from 'react'
import { Link } from 'react-router-dom'
import GhostButton from '@softwaredev_cegeka/stix-core/dist/components/Button/subcomponents/GhostButton'
import Card from '@softwaredev_cegeka/stix-core/dist/components/Card'
import Pagination from '@softwaredev_cegeka/stix-core/dist/components/Pagination'
import Filter from '@softwaredev_cegeka/stix-filter/dist/components/Filter'
import { authenticatedUserStore, newsStore } from '../../stores'
import NewsStore from '../../stores/NewsStore'
import DataTableHelpers from '../DataTable/DataTableHelpers'
import { DataTable } from '../index'
import { authorize } from '../index'

class Articles extends React.Component {
    componentDidMount() {
        newsStore.loadNews()
    }

    organizationData() {
        return authenticatedUserStore.userOrganizations.map(organization => ({
            value: organization.organization_id,
            label: organization.name,
        }))
    }

    state = {
        currentPage: 1,
        filterValues: [],
    }

    handlePageChange = page => {
        this.setState({
            currentPage: page,
        })
        newsStore.loadNews(page, this.state.filterValues)
    }

    applyHeaderFilters = values => {
        if (
            'incident_type' in values &&
            (values['incident_type'] === 'P1' ||
                values['incident_type'] === 'P2')
        ) {
            values['type'] = 'Incident'
        }
        newsStore.loadNews(1, values)
        this.setState({
            filterValues: values,
        })
    }

    render() {
        const filters = [
            {
                field: 'incident_type',
                label: 'Incident type',
                options: ['P1', 'P2'],
            },
            {
                field: 'author_like',
                label: 'Author',
            },
            {
                field: 'type',
                label: 'Type',
                options: [
                    'News',
                    'Knowledge',
                    'Incident',
                    'FAQ',
                    'Policy',
                    'Unknown',
                ],
            },
            {
                field: 'visible',
                label: 'Visible',
                options: [
                    { value: 'true', label: 'True' },
                    { value: 'false', label: 'False' },
                ],
            },
            {
                field: 'target_audience',
                label: 'Target audience',
                options: this.organizationData(),
            },
        ]
        return (
            <Card>
                <Card.Header align="space-between">
                    {authenticatedUserStore.isAllowed('WRITE') ? (
                        <GhostButton as={Link} to={'/articles/new'}>
                            Add article
                        </GhostButton>
                    ) : null}

                    {DataTableHelpers.renderTableLegend(NewsStore.STATUS_MAP)}
                </Card.Header>
                <Card.Body>
                    <Filter
                        filters={filters}
                        activeFilters={this.state.filterValues}
                        onFilterChange={this.applyHeaderFilters}
                    />
                    <hr />
                    <DataTable data={newsStore.news} />
                </Card.Body>
                <Card.Footer align="center">
                    <Pagination
                        lastPage={newsStore.totalPages}
                        currentPage={this.state.currentPage}
                        onClick={this.handlePageChange}
                    />
                </Card.Footer>
            </Card>
        )
    }
}

export default authorize(observer(Articles), 'READ')
